import React from 'react';
import axios from "../../../../../containers/api";
import {showCatchError, toEnglishNumbers} from "../../../../../helpers/Utils";
import {Button, CardBody, Input, Row, Alert, FormGroup, Label, CustomInput} from "reactstrap";
import {Colxx} from "../../../../../components/common/CustomBootstrap";

class AddProductOwner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: [], 
            firstName: "",
            lastName: "",
            meliCode: "",
            mobile: "",
            
        }
    }

    validate = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.firstName.length < 3) {
            error.push('لطفا نام را وارد کنید');
        }
        if (this.state.meliCode.length < 10) {
            error.push('لطفا کد ملی وارد کنید');
        }
        if (this.state.mobile.length < 11) {
            error.push('لطفا موبایل را وارد کنید');
        }
        if (this.state.IsHaghighy === 1 && this.state.lastName < 5) {
            error.push('لطفا نام خانوادگی را وارد کنید');
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.AddProductOwner();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddProductOwner = () => {
        const addModel = {
            Firstname: toEnglishNumbers(this.state.firstName),
            LastName: toEnglishNumbers(this.state.lastName)  , 
            Mobile: toEnglishNumbers(this.state.mobile),
            MeliCode: toEnglishNumbers(this.state.meliCode),
            
        };

        this.props.showSpinner();
        axios.post('/api/v1/ProductOwner/AddProductOwner', addModel)
            .then((res) => {
                this.props.hideSpinner();
                 
                if (res.data.data.code !== 1 && res.data.data.code !== "1") {
                    this.props.showAlert(res.data.data.message, "error");
                } else {
                    this.props.showAlert(res.data.data.message, "success");
                    
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
            });
    };

    handleRadioChange = (e, value) => {
        const { name, id } = e.target;
        this.setState({[name]: value});
    };

    render() {
        return (
            <Row className="d-flex justify-content-center">
                <Colxx md="10" xxs="12">
                    <CardBody className="d-flex flex-column">
                       

                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>*نام</Label>
                                <Input value={this.state.firstName} maxLength={50}
                                       onChange={(e) => this.setState({firstName: e.target.value})}/>
                            </FormGroup>

                           
                                <FormGroup className="w-md-30 w-100 px-1">
                                    <Label>نام خانوادگی</Label>
                                    <Input value={this.state.lastName} maxLength={50}
                                           onChange={(e) => this.setState({lastName: e.target.value})}/>
                            </FormGroup>
                        </div>
                        <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">

                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>*کد ملی</Label>
                                <Input value={this.state.meliCode} maxLength={50}
                                       onChange={(e) => this.setState({meliCode: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                            <FormGroup className="w-md-30 w-100 px-1">
                                <Label>موبایل</Label>
                                <Input value={this.state.mobile} maxLength={11}
                                       onChange={(e) => this.setState({mobile: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                            </FormGroup>

                            
                        </div>

                        {this.state.errors.length === 0 ?
                            null
                            :
                            <div>
                                {(this.state.errors.map((error, i) => {
                                    return (
                                        <Alert color="danger" key={i}>{error}</Alert>
                                    )
                                }))}
                            </div>
                        }

                        <div className="d-flex mt-2 justify-content-center">
                            <FormGroup className="text-center">
                                <Button color="primary" className="btn-lg mx-2"
                                        onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validate)}>
                                    ثبت
                                </Button>
                            </FormGroup>
                        </div>
                    </CardBody>
                </Colxx>
            </Row>
        );
    }
}

export default AddProductOwner;